import $ from "jquery";
import config from '../../lib/config';

const posts = config.workPosts;

export default class WorkPosts {
	
	static setHeightEachPost() {	
		if ( posts.length > 0 ) {
			$(posts).each( function(i, post) {
				let postImg = $(post).find('.entry-image'),
						imgHeight = $(postImg).height();

				$(post).find('.post-work-inner').height(imgHeight);
			});
		}
	}

	static removeHeightEachPost() {
		if ( posts.length > 0 ) {
			$(posts).each( function(i, post) {
				$(post).find('.post-work-inner').height('auto');
			});
		}
	}

	static setHeight() {
		var windowSize = $(window).width();
		
		if ( windowSize > 991 ) {
			$(window).load(function() {
				WorkPosts.setHeightEachPost();
			});
		}

		$(window).on('resize', function () {

			if ( $(this).width() > 991 ) {
				WorkPosts.setHeightEachPost();
			} else {
				WorkPosts.removeHeightEachPost();
			}			
		});

	}

}